<template>
    <b-card no-body>
        <UpdateSmsTemplatesModal :update_sms_templates.sync="modals.update_sms_templates" :customerSubStatusList="customerSubStatusList" v-on:closeModal="closeModal()" :template_data="template_data" />
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
            </b-row>
        </b-col>

         <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"

                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed="left"
                    height="500"
                ></el-table-column>
    
                <el-table-column
                prop="sms_title"
                label="Title"
                sortable
                >
                <template slot-scope="scope">
                    <p class="text-capitalize" >{{ scope.row.sms_title }}</p>
                </template>
                </el-table-column>

                <el-table-column
                prop="sms_content"
                label="Content"
                sortable
                >
                <template slot-scope="scope">
                    <p class="font-weight-bold text-primary">{{ scope.row.sms_content }}</p>
                </template>
                </el-table-column>

                <el-table-column
                prop=""
                label="Customer Sub Status"
                sortable
                >
                <template slot-scope="scope">
                    <p class="font-weight-bold">{{ _gHlp.getValue(scope.row, 'customer_status_details.parent_status', ' ') }} - {{ _gHlp.getValue(scope.row, 'customer_status_details.status', ' ') }}</p>
                </template>
                </el-table-column>


                <!-- STATUS CREATED BY COLUMN -->
                <el-table-column
                    prop="created_by"
                    label="Created By"
                    sortable    
                >
                <template slot-scope="scope">
                    <p>{{ _gHlp.getValue(scope.row, 'created_by_detail.name', ' ') }}</p>
                </template>
                </el-table-column>

                <!-- STATUS CREATED AT COLUMN -->
                <el-table-column
                    prop="created_at"
                    label="Date Created"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                    
                </el-table-column>

                <!-- STATUS ACTIONS COLUMN -->
                <el-table-column
                    width="55"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown :tabindex="scope.row.id" class="py-2">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="editTemplate(scope.row)">
                                    Edit
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="deleteTemplate(scope.row.sms_template_id)">
                                    Delete
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import mainEventBus from '@/assets/js/mainEventBus.js'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import UpdateSmsTemplatesModal from '@/views/Configurations/SmsTemplates/SmsTemplatesModals/UpdateSmsTemplatesModal'
import { useMessagingStore } from '../../../stores/messagingStore'
import { mapState, mapActions } from 'pinia'

export default {
    props: ['customerSubStatusList'],
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        UpdateSmsTemplatesModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            modals: {
                update_sms_templates: false,
            },
            isTableLoading: true,
            propsToSearch:['sms_title', 'sms_content'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            template_data: {},
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500]
            },
        }
    },
    created(){
        this.getTemplate()
    },  
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);

        mainEventBus.$on('refresh-status', this.getTemplate)
    },
    beforeUnmount() {
        mainEventBus.$off('refresh-status', this.getTemplate)
    },
     methods: {
		...mapActions(useMessagingStore, ['getSmsTemplates']),
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        async getTemplate(){
            this.isTableLoading = true
            this.tableData = await this.getSmsTemplates()
            // Map through tableData and add the details from customerSubStatusList
            this.tableData = this.tableData.map(template => {
                let matchedStatus = this.customerSubStatusList.find(status => status.status_id === template.customer_status_id);

                if (matchedStatus) {
                    // Add the details to the template object
                    return {
                        ...template, 
                        customer_status_details: matchedStatus
                    };
                }
                
                return template;
            });
            this.isTableLoading = false
        },
        editTemplate(template){
            this.template_data = template
            this.modals.update_sms_templates = true;
        },
        deleteTemplate(sms_template_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.messaging + 'sms-template/' + sms_template_id, {headers: getHeader()})
                    .then(res => {
                            this.getTemplate()
                            this.notifySuccess('<b>Status: </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                }
            })
        },
        closeModal(){
            this.modals.update_sms_templates = false
        },
    }
}
</script>